// All Validation functions validate to true if conditions are met.

export const isEmpty = (value: string) => {
  return value.trim().length < 1;
};

export const isOnlyNumbers = (value: string) => {
  return /^[0-9]*$/g.test(value);
};

export const isSpecificLength = (value: string, length: number) => {
  return value.trim().length === length;
};

export const isValidEmail = (value: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const isValidPassword = window.altibox.validators.userpassword;
